export const toSafeWhitespaceString = (value) => {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .trim();
};
